import {extend, localize} from 'vee-validate';
import {email, required, confirmed} from 'vee-validate/dist/rules';
import ru from 'vee-validate/dist/locale/ru.json';

// Add a rule.
extend('required', required);
extend('email', email);
extend('confirmed', confirmed);

localize('ru', ru);
